module.exports = __webpack_public_path__ + "assets/img/thr3.c7e3dd14.png";